import React, { useEffect } from "react";
import "./GeopPrivacy.css";

const TITLE = "プライバシーポリシー | Geop";

export default function GeopPrivacy() {
  useEffect(() => {
    const prev = document.title;
    document.title = TITLE;
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="geop-privacy-page">
      <main className="geop-privacy-wrap">
        <h1>プライバシーポリシー</h1>
        <span className="last-updated">最終更新日: 2026年2月</span>

        <section>
          <h2>1. はじめに</h2>
          <p>
            位置情報特化型ソーシャルネットワークサービス「Geop」（以下「本サービス」といいます。）を運営する当社（以下「当社」といいます。）は、ユーザーの個人情報の保護に関する法令を遵守し、以下のプライバシーポリシー（以下「本ポリシー」といいます。）に従って、適切に取り扱うものとします。
          </p>
        </section>

        <section>
          <h2>2. 収集する個人情報</h2>
          <p>当社は、本サービスの提供に必要な以下の個人情報を収集します。</p>
          <p>
            <span className="sub">2.1 基本情報</span>
          </p>
          <p>• 氏名、ニックネーム、アカウント名</p>
          <p>• メールアドレス、電話番号</p>
          <p>• 生年月日、性別</p>
          <p>• プロフィール画像、自己紹介文</p>
          <p>• 居住地、出身地（都道府県レベル）</p>
          <p>
            <span className="sub">2.2 位置情報</span>
          </p>
          <p>• 現在地情報（緯度・経度）</p>
          <p>• 投稿時の位置情報</p>
          <p>• 移動履歴（オプション）</p>
          <p>• 訪問した場所の記録</p>
          <p>
            <span className="sub">2.3 サービス利用情報</span>
          </p>
          <p>• 投稿内容（テキスト、画像、動画）</p>
          <p>• いいね、コメント、ブックマークの記録</p>
          <p>• 友達関係、フォロー関係</p>
          <p>• メッセージの内容</p>
          <p>• アプリの利用状況、アクセスログ</p>
          <p>
            <span className="sub">2.4 デバイス情報</span>
          </p>
          <p>• デバイス識別子（UUID）</p>
          <p>• オペレーティングシステム情報</p>
          <p>• アプリバージョン情報</p>
          <p>• IPアドレス、アクセス日時</p>
        </section>

        <section>
          <h2>3. 個人情報の利用目的</h2>
          <p>当社は、収集した個人情報を以下の目的で利用します。</p>
          <p>
            <span className="sub">3.1 サービス提供</span>
          </p>
          <p>• 本サービスの提供・運営</p>
          <p>• ユーザー認証・アカウント管理</p>
          <p>• 投稿の表示・管理</p>
          <p>• 位置情報に基づく機能の提供</p>
          <p>• 近隣ユーザーとのマッチング</p>
          <p>
            <span className="sub">3.2 コミュニケーション</span>
          </p>
          <p>• メッセージ機能の提供</p>
          <p>• 友達機能の提供</p>
          <p>• 通知機能の提供</p>
          <p>• カスタマーサポート</p>
          <p>
            <span className="sub">3.3 サービス改善</span>
          </p>
          <p>• 利用状況の分析</p>
          <p>• 機能の改善・新機能の開発</p>
          <p>• パフォーマンスの最適化</p>
          <p>• ユーザー体験の向上</p>
          <p>
            <span className="sub">3.4 安全性の確保</span>
          </p>
          <p>• 不正利用の防止・検出</p>
          <p>• スパム・迷惑行為の対策</p>
          <p>• 利用規約違反の監視</p>
          <p>• セキュリティの維持・向上</p>
        </section>

        <section>
          <h2>4. 位置情報の特別な取り扱い</h2>
          <p>
            本サービスは位置情報を活用したサービスであるため、位置情報の取り扱いについて特別に定めます。
          </p>
          <p>
            <span className="sub">4.1 位置情報の収集</span>
          </p>
          <p>• 位置情報は、ユーザーの明示的な同意を得た場合にのみ収集します</p>
          <p>• 位置情報の収集は、本サービスの利用に必要な最小限の範囲に限定します</p>
          <p>• 位置情報の精度は、サービス提供に必要な範囲に調整します</p>
          <p>
            <span className="sub">4.2 位置情報の利用</span>
          </p>
          <p>• 投稿の位置表示</p>
          <p>• 近隣ユーザーとのマッチング</p>
          <p>• 地域特化コンテンツの提供</p>
          <p>• 安全なサービス運営のための監視</p>
          <p>
            <span className="sub">4.3 位置情報の管理</span>
          </p>
          <p>• ユーザーは位置情報の表示範囲を設定できます（公開/非公開）</p>
          <p>• 位置情報の取得を停止した場合、一部機能が利用できなくなる場合があります</p>
        </section>

        <section>
          <h2>5. 個人情報の第三者提供</h2>
          <p>当社は、以下の場合を除き、個人情報を第三者に提供しません。</p>
          <p>• ユーザーの同意がある場合</p>
          <p>• 法令に基づく場合</p>
          <p>• 人の生命、身体または財産の保護のために必要がある場合</p>
          <p>• 公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合</p>
          <p>
            •
            国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合
          </p>
          <p>• 統計データとして加工された情報（個人を特定できない形式）の提供</p>
        </section>

        <section>
          <h2>6. 個人情報の委託</h2>
          <p>
            当社は、本サービスの提供に必要な範囲で、個人情報の取扱いを外部に委託する場合があります。この場合、当社は委託先に対して適切な監督を行い、個人情報の安全管理が図られるよう必要な措置を講じます。
          </p>
        </section>

        <section>
          <h2>7. 個人情報の保存期間</h2>
          <p>当社は、個人情報を以下の期間保存します。</p>
          <p>• アカウント情報：アカウント削除まで</p>
          <p>• 投稿内容：アカウント削除後30日間</p>
          <p>• 位置情報：投稿削除後30日間</p>
          <p>• アクセスログ：1年間</p>
          <p>• 法令で定められた保存期間がある場合は、その期間</p>
        </section>

        <section>
          <h2>8. 個人情報の安全管理</h2>
          <p>
            当社は、個人情報の漏洩、滅失または毀損の防止その他の安全管理のため、以下の措置を講じます。
          </p>
          <p>• アクセス制御の実施</p>
          <p>• 暗号化技術の採用</p>
          <p>• 定期的なセキュリティ監査</p>
          <p>• 従業員への教育・研修</p>
          <p>• 物理的セキュリティの確保</p>
        </section>

        <section>
          <h2>9. ユーザーの権利</h2>
          <p>ユーザーは、以下の権利を有します。</p>
          <p>
            <span className="sub">9.1 開示請求</span>
          </p>
          <p>当社が保有する個人情報の開示を求めることができます。</p>
          <p>
            <span className="sub">9.2 訂正・削除請求</span>
          </p>
          <p>個人情報の訂正、追加、削除を求めることができます。</p>
          <p>
            <span className="sub">9.3 利用停止請求</span>
          </p>
          <p>個人情報の利用停止、消去を求めることができます。</p>
          <p>
            <span className="sub">9.4 第三者提供停止請求</span>
          </p>
          <p>個人情報の第三者提供の停止を求めることができます。</p>
        </section>

        <section>
          <h2>10. クッキー・類似技術</h2>
          <p>
            当社は、本サービスの提供に必要な範囲で、クッキーや類似の技術を使用します。これらの技術は、以下の目的で使用されます。
          </p>
          <p>• ユーザー認証の維持</p>
          <p>• 利用状況の分析</p>
          <p>• サービス改善</p>
          <p>• 広告配信の最適化</p>
          <p>
            ユーザーは、ブラウザの設定によりクッキーの受け入れを拒否することができますが、一部機能が利用できなくなる場合があります。
          </p>
        </section>

        <section>
          <h2>11. 未成年者の個人情報</h2>
          <p>
            当社は、未成年者の個人情報について、特に慎重に取り扱います。未成年者が本サービスを利用する場合は、保護者の同意を得ることを推奨します。
          </p>
        </section>

        <section>
          <h2>12. プライバシーポリシーの変更</h2>
          <p>
            当社は、法令の変更やサービス内容の変更に伴い、本ポリシーを変更することがあります。変更する場合は、本サービス上で通知し、またはメール等でお知らせします。
          </p>
        </section>

        <section>
          <h2>13. お問い合わせ</h2>
          <p>個人情報の取り扱いに関するお問い合わせは、以下までご連絡ください。</p>
          <p>
            <span className="sub">Geop プライバシー担当</span>
          </p>
          <p>メール: gluontech@gluon.jp</p>
          <p>受付時間: 平日 9:00-18:00</p>
        </section>

        <p className="closing">以上</p>
      </main>
    </div>
  );
}
